import { CampaignObject } from "../types/APITypes";
import api from "../util/axios";

export const QUARTERS = ["1", "2", "3", "4"];
var currentTime = new Date();
var year = currentTime.getMonth() < 1 ? currentTime.getFullYear() % 100 : (currentTime.getFullYear() % 100) + 1;
console.log(year, currentTime.getMonth(), currentTime);
export const YEARS = [year.toString(), (year + 1).toString(), (year + 2).toString()];

function get_static_years(year: number): string[] {
  let start = 24;
  let years: string[] = [];

  while (start <= year + 1) {
    years.push(start.toString());
    start++;
  }
  return years;
}

export const STATIC_YEARS = get_static_years(year);

export const CAMPAIGN_OBJECTIVE = [
  "Brand Awareness",
  "Lead Generation",
  "Meeting Generation",
  "Pipeline Generation",
  "Opportunity Acceleration",
  "Customer Upsell",
];

export const CAMPAIGN_SOURCE = ["Paid/Sponsored (NOT Partner)", "Owned", "Partner", "Owned - Braze@Braze"];
export const BUDGET_SOURCE = [
  "Regional Marketing",
  "MarOps",
  "Partner Marketing",
  "Customer Marketing",
  "Brand",
  "GSA",
  "Global Campaigns",
  "Social Impact",
];

export const CAMPAIGN_REGION = ["Global", "AMER", "APAC", "EMEA", "Japan"];

export const CAMPAIGN_SUBREGIONS = [
  "AMER - EAST",
  "AMER - WEST",
  "AMER - CENTRAL",
  "AMER - LATAM",
  "APAC - ANZ",
  "APAC - GCC",
  "APAC - KR",
  "APAC - SEA",
  "EMEA - NORTH",
  "EMEA - SOUTH",
  "EMEA - CENTRAL",
];

export const MARKETING_PROGRAMS = {
  "Other Field Marketing": "a35VP0000003N3JYAU",
  Lifecycle: "a35VP0000002YtdYAE",
  Partnerships: "a35VP0000002WdJYAU",
  "General Demand": "a35VP0000001xhBYAQ",
  "Industry Campaigns": "a35VP0000003N1hYAE",
  Forge: "a35VP0000001xkPYAQ",
  "Grow with Braze": "a35VP0000001xndYAA",
  "GSA Campaigns": "a35VP0000001xu5YAA",
  "Global Campaigns": "a35VP0000001xinYAA",
  "City x City": "a35VP0000001xm1YAA",
  Product: "a35VP000000C4avYAC",
};

export const REQUIRED_FIELDS: (keyof CampaignObject)[] = [
  "campaign_region",
  "campaign_subregion",
  "campaign_name",
  "start_date",
  "end_date",
  "fiscal_year",
  "fiscal_quarter",
  "campaign_description",
  "campaign_owner",
  "campaign_owner_email",
  "campaign_type",
  "parent_campaign",
  "campaign_objective",
  "campaign_source",
  "nnl_projected_count",
  "mql_projected_count",
  "sql_projected_count",
  "pipe_count_projected",
  "pipe_amount_projected",
  "audience_type",
];

export const MARKETO_REGIONS = ["Global", "Korea"];

export const MARKETO_DATE = ["Yes", "No"];

export const AUDIENCE_TYPE = ["Customer", "Prospect", "Both"];

export const INDUSTRY = [
  "Education",
  "Financial Services",
  "Government & Non-Profit",
  "Healthcare & Life Sciences",
  "Logistics & Utilities",
  "Manufacturing",
  "Media & Entertainment",
  "Professional Services",
  "Restaurants & On-Demand",
  "Retail & Consumer Goods",
  "Technology",
  "Telecommunications",
  "Travel, Transportation, & Hospitality",
];
